// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_GFc5w {
    height : 100%;
}

.contentFooter_y3s4I {
    position: sticky !important;
    display: flex !important;
    background-color: white;
    bottom: 0;
    padding: 5px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/dataViewers/dashboard/DashboardView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB","sourcesContent":[".dashboard {\n    height : 100%;\n}\n\n.contentFooter {\n    position: sticky !important;\n    display: flex !important;\n    background-color: white;\n    bottom: 0;\n    padding: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `dashboard_GFc5w`,
	"contentFooter": `contentFooter_y3s4I`
};
export default ___CSS_LOADER_EXPORT___;
